import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import sobreContent from "../Sobre_Admin.md?raw";

interface AboutDialogProps {
  open: boolean;
  onClose: () => void;
}

export const AboutDialog = ({ open, onClose }: AboutDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Admin - Cadastro de usuários e de licenças de uso dos produtos da Pelli Sistemas</DialogTitle>
    <DialogContent dividers>
      <Box
        component="pre"
        sx={{
          fontFamily: "monospace",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: "0.875rem",
          lineHeight: 1.7,
          margin: 0,
        }}
      >
        {sobreContent}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained">
        Fechar
      </Button>
    </DialogActions>
  </Dialog>
);
